import { render, staticRenderFns } from "./Resetpw.vue?vue&type=template&id=6a1394b4&"
import script from "./Resetpw.vue?vue&type=script&lang=js&"
export * from "./Resetpw.vue?vue&type=script&lang=js&"
import style0 from "./Resetpw.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports